import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Form as FormModule } from 'billon-ui';
const { FormGroup, TextField } = FormModule;

export const ControlledTextField = ({
  name,
  disabled,
  label,
  placeholder,
  clean,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <FormGroup>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            input={field}
            meta={{
              touched: fieldState.invalid,
              error: errors?.[field.name]?.message,
            }}
            disabled={disabled}
            placeholder={placeholder}
            label={label}
            clean={clean}
          />
        )}
      />
    </FormGroup>
  );
};
